export default __webpack_public_path__ + "static/media/threaded-message.d845cc3f.svg";